import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {UfStepStatusEnum} from "../enum/uf-step-status.enum";
import {UfFlowStepActivityDto} from "./uf-flow-step-activity.dto";

export class UfFlowStepDto extends DtoDetail {

    public flowDtoId: number;
    public flowDtoName: string;

    public flowTypeStepDtoId: number;
    public flowTypeStepDtoName: string;

    public stepKey: string;
    public stepOrder: number;

    public status: UfStepStatusEnum;
    public visible: boolean;
    public notVisibleReason: string;

    public enteredAt: Date;
    public completedAt: Date;

    public validated: boolean;
    public validationErrors: string;

    public activities?: UfFlowStepActivityDto[];

    public getValidationErrorsArray(): string[] {
        if (!this.validationErrors) {
            return [];
        }
        try {
            return JSON.parse(this.validationErrors);
        } catch {
            return [];
        }
    }
}
